import layout from '@/views/layout/layout.vue'
const kadierInfoList = r => require.ensure([], () => r(require('@/views/marketing/kadierInfo/list.vue')), 'group-marketing-kadierInfo')

const marketingKadierInfo = [
  {
    path: '/marketing/kadierInfo',
    name: 'marketing-kadierInfo',
    component: layout,
    redirect: '/marketing/kadierInfo/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: kadierInfoList,
        name: 'marketing-kadierInfo-list',
        meta: {
          displayName: '卡迪尔获取信息管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default marketingKadierInfo



// WEBPACK FOOTER //
// ./src/router/marketing/kadierInfo.js